module.exports = __webpack_public_path__ + "img/syzn3.0b9a3c90.png";